import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { NzI18nModule } from '../i18n/nz-i18n.module';
import { NzWysiwygNetComponent } from './wysiwyg-net.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [ NzWysiwygNetComponent ],
  exports     : [ NzWysiwygNetComponent ],
  imports     : [ CommonModule, FormsModule, FroalaEditorModule, FroalaViewModule, NzI18nModule ]
})
export class NzWysiwygNetModule {
}
